(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7926],{

/***/ 38562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var firebase_remote_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12971);
/* harmony import */ var utils_firebase__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18945);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);
 // import getConfig from "next/config";







var ElectionsWidget = function ElectionsWidget() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    electionExitPollToggle: false,
    electionResultToggle: true,
    vidhansabhaResultToggle: true,
    resultVersion: 1.6,
    exitPollVersion: 1.2,
    electionYear: 2024,
    isElectionAlpha: true,
    keyCandidate: true
  }),
      publicRuntimeConfig = _useState[0],
      setPublicRunTimeConfig = _useState[1]; // const { publicRuntimeConfig } = getConfig();


  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true),
      lokExit = _useState2[0],
      setLokExit = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (true) {
      var remoteConfig = (0,firebase_remote_config__WEBPACK_IMPORTED_MODULE_1__/* .getRemoteConfig */ .sN)(utils_firebase__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z);
      remoteConfig.settings.minimumFetchIntervalMillis = 3600000;
      (0,firebase_remote_config__WEBPACK_IMPORTED_MODULE_1__/* .fetchAndActivate */ .xS)(remoteConfig).then(function () {
        var titleData = (0,firebase_remote_config__WEBPACK_IMPORTED_MODULE_1__/* .getString */ .KF)(remoteConfig, "electionKeys");
        var parsedData = JSON.parse(titleData);
        setPublicRunTimeConfig(parsedData); // console.log("Election Keys are ", (parsedData))
        // setVideoUrl(titleData);
      })["catch"](function (err) {
        console.error(err);
      });
    }
  }, []); // console.log(
  //   "ElectionWidges are",
  //   publicRuntimeConfig?.electionExitPollToggle
  // );

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: (publicRuntimeConfig === null || publicRuntimeConfig === void 0 ? void 0 : publicRuntimeConfig.electionExitPollToggle) === true && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      className: "election-result-tally",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("h2", {
        style: {
          paddingLeft: "10px",
          fontWeight: "700",
          fontSize: "22px",
          paddingTop: "10px",
          paddingBottom: "5px",
          background: "white"
        },
        children: "\u090F\u0917\u094D\u091C\u093F\u091F \u092A\u094B\u0932"
      }), lokExit ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("iframe", {
        width: "100%",
        height: "370px",
        scrolling: "no" // src= "https://electionresults.intoday.in/elections/2024/loksabha-elections/html/exit-poll/lok-sabha-exit-poll.html?site=lallantop&theme=1&v=1.0"
        ,
        src: "https://electionresults.intoday.in/elections/2024/loksabha-elections/html/loksabhastate-exitpoll/lok-sabha-exit-poll.html?site=lallantop&theme=1&v=5.0"
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("iframe", {
        width: "100%",
        height: "340px",
        scrolling: "no",
        src: "https://electionresults.intoday.in/elections/2024/assembly-elections/html/exit-poll/assembly-exit-poll.html?site=lallantop&device=web&v=5.1"
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (ElectionsWidget);

/***/ }),

/***/ 5317:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var api_commonConstants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96781);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10682);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


 // import CustomIframe from './CustomIframe';





function Tally(_ref) {
  var masterConfig = _ref.masterConfig,
      showExitTally = _ref.showExitTally,
      showResultTally = _ref.showResultTally,
      stateName = _ref.stateName;
  var size = (0,api_commonConstants__WEBPACK_IMPORTED_MODULE_1__/* .useWindowSize */ .iP)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: [showExitTally != false && (masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Exittally) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
      children: size.width < 768 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        className: "result-page",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h2", {
          style: {
            fontSize: "27px",
            color: "#D9368B",
            fontWeight: "800"
          },
          children: "\u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u090F\u0917\u094D\u095B\u093F\u091F \u092A\u094B\u0932"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("iframe", {
            scrolling: "no",
            src: !stateName ? "".concat(masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Exittally_URL) : "".concat(masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Exittally_URL, "&state_name=").concat(stateName),
            width: "100%",
            height: masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Exitpolltally_height_mobile
          })
        })]
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
          className: "result-page  ",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h2", {
            style: {
              fontSize: "27px",
              color: "#D9368B",
              fontWeight: "800"
            },
            children: "\u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u090F\u0917\u094D\u095B\u093F\u091F \u092A\u094B\u0932"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("iframe", {
              scrolling: "no",
              src: !stateName ? "".concat(masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Exittally_URL) : "".concat(masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Exittally_URL, "&state_name=").concat(stateName),
              width: "100%",
              height: masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Exitpolltally_height_web
            })
          })]
        })
      })
    }), showResultTally != false && (masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Resulttally) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
      children: size.width < 768 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        className: "result-page-big",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h2", {
          style: {
            fontSize: "27px",
            color: "#D9368B",
            fontWeight: "800"
          },
          children: "\u0926\u093F\u0932\u094D\u0932\u0940 \u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u0930\u093F\u091C\u0932\u094D\u091F"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("iframe", {
            scrolling: "no",
            src: !stateName ? "".concat(masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Resulttally_URL) : "".concat(masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Resulttally_URL, "&state_name=").concat(stateName),
            width: "100%",
            height: masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Resulttally_height_mobile
          })
        })]
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
          className: "result-page-big",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h2", {
            style: {
              fontSize: "27px",
              color: "#D9368B",
              fontWeight: "800"
            },
            children: "\u0926\u093F\u0932\u094D\u0932\u0940 \u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u0930\u093F\u091C\u0932\u094D\u091F"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("iframe", {
              scrolling: "no",
              src: !stateName ? "".concat(masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Resulttally_URL) : "".concat(masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Resulttally_URL, "&state_name=").concat(stateName),
              width: "100%",
              height: size.width != 768 && size.width <= 1000 ? masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Resulttally_height_tab_internal : masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Resulttally_height_web // height={(size.width != 768 && size.width <= 1000 )? masterConfig.Maharashtra_Resulttally_height_tab_internal   :
              //   masterConfig
              //     .Maharashtra_Resulttally_height_web
              // }
              // height={(window.innerWidth != 768 && window.innerWidth <= 1000) ? masterConfig?.Maharashtra_Resulttally_height_tab_internal :  masterConfig?.Maharashtra_Resulttally_height_web}

            })
          })]
        })
      })
    }), (masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.BypollResulttally) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
      children: size.width < 768 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        className: "result-page-big",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h2", {
          style: {
            fontSize: "27px",
            color: "#D9368B",
            fontWeight: "800"
          },
          children: "\u0909\u092A\u091A\u0941\u0928\u093E\u0935 \u0930\u093F\u091C\u0932\u094D\u091F"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("iframe", {
            scrolling: "no",
            src: masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.BypollResulttally_URL,
            width: "100%",
            height: masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Bypoll_Resulttally_height_mobile
          })
        })]
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        className: "result-page-big",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h2", {
          style: {
            fontSize: "27px",
            color: "#D9368B",
            fontWeight: "800"
          },
          children: "\u0909\u092A\u091A\u0941\u0928\u093E\u0935 \u0930\u093F\u091C\u0932\u094D\u091F"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("iframe", {
            scrolling: "no",
            src: masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.BypollResulttally_URL,
            width: "100%",
            height: masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Bypoll_Resulttally_height_web
          })
        })]
      })
    })]
  });
}

/* harmony default export */ __webpack_exports__["Z"] = (Tally);

/***/ }),

/***/ 19784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var SearchableDropdown = function SearchableDropdown(_ref) {
  var options = _ref.options,
      label = _ref.label,
      id = _ref.id,
      selectedVal = _ref.selectedVal,
      handleChange = _ref.handleChange;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""),
      query = _useState[0],
      setQuery = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var inputRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    document.addEventListener("click", toggle);
    return function () {
      return document.removeEventListener("click", toggle);
    };
  }, []);

  var selectOption = function selectOption(option) {
    setQuery(function () {
      return "";
    });
    handleChange({
      label: option.label,
      value: option.value
    });
    setIsOpen(function (isOpen) {
      return !isOpen;
    });
  };

  function toggle(e) {
    setIsOpen(e && e.target === inputRef.current);
  }

  var getDisplayValue = function getDisplayValue() {
    if (query) return query;
    if (selectedVal) return selectedVal;
    return "";
  };

  var filter = function filter(options) {
    return options.filter(function (option) {
      return option.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
    });
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
    className: "dropdown",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
      className: "control",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: "selected-value",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
          ref: inputRef,
          type: "text",
          value: getDisplayValue(),
          name: "searchTerm",
          onChange: function onChange(e) {
            setQuery(e.target.value);
            handleChange(null);
          },
          onClick: toggle
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: "arrow ".concat(isOpen ? "open" : "")
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      className: "options ".concat(isOpen ? "open" : ""),
      children: filter(options).map(function (option, index) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
          onClick: function onClick() {
            return selectOption(option);
          },
          className: "option ".concat(option.label === selectedVal ? "selected" : ""),
          children: option.label
        }, "".concat(id, "-").concat(index));
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (SearchableDropdown);

/***/ }),

/***/ 79370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Index; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./src/localization/i8intl.js + 2 modules
var i8intl = __webpack_require__(54269);
// EXTERNAL MODULE: ./src/api/commonConstants.js
var commonConstants = __webpack_require__(96781);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./src/components/vidhansabha/SearchableDropdown.js
var SearchableDropdown = __webpack_require__(19784);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/elections-2023/ElectionsWidget.js
var ElectionsWidget = __webpack_require__(38562);
// EXTERNAL MODULE: ./src/constants/MasterConfigContext.js
var MasterConfigContext = __webpack_require__(39712);
// EXTERNAL MODULE: ./src/components/tally/Tally.jsx
var Tally = __webpack_require__(5317);
// EXTERNAL MODULE: ./src/constants/state.js
var constants_state = __webpack_require__(25613);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/vidhansabha/KaunJeetaConsD.js





 // import Link from "next/link";


 // import Dropdown from "react-dropdown";
// import "react-dropdown/style.css";


 // import getConfig from "next/config";




 // import { FormattedMessage } from "react-intl";




function KaunJeetaConsD(_ref) {
  var _colorOptions, _currentConstData$, _currentConstData$2, _currentConstData$3, _currentConstData$4, _currentConstData$5, _currentConstData$6, _currentConstData$7, _currentConstData$8, _currentConstData$9, _ConstituencyListData, _ConstituencyListData2, _ConstituencyListData3, _ConstituencyListData7, _ConstituencyListData8, _ConstituencyListData9, _ConstituencyListData10, _ConstituencyListData11, _ConstituencyListData12, _ConstituencyListData13, _ConstituencyListData14, _ConstituencyListData15, _resultYearData$, _resultYearData$2, _resultYearData$3, _resultYearData$4, _resultYearData$5, _resultYearData$6, _ConstituencyListData16;

  var consId = _ref.consId,
      state = _ref.state,
      stateHindi = _ref.stateHindi,
      consName = _ref.consName,
      masterKey = _ref.masterKey,
      cYear = _ref.cYear,
      ConstituencyListData2024 = _ref.ConstituencyListData2024,
      ConstituencyListData2019 = _ref.ConstituencyListData2019,
      constituencyArray = _ref.constituencyArray,
      tabs = _ref.tabs,
      breadCrump = _ref.breadCrump,
      electionState = _ref.electionState,
      prevYear = _ref.prevYear;
  var electionsData = (0,react.useContext)(MasterConfigContext/* MasterConfigContext */.d);
  var masterConfig = electionsData === null || electionsData === void 0 ? void 0 : electionsData[masterKey]; // const [currentYear, setCurrentYear] = useState(2020);

  var _useState = (0,react.useState)(masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.electionYear_KJKH_detail),
      currentYear = _useState[0],
      setCurrentYear = _useState[1];

  var displayYear = masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.displayYear;
  var dryRun = masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.dryRun; // const [currentYear, setCurrentYear] = useState(2019);
  // const [currentYear, setCurrentYear] = useState(${displayYear});

  var _useState2 = (0,react.useState)(prevYear[0]),
      restDataYear = _useState2[0],
      setRestDataYear = _useState2[1]; // const [resultYearData, setResultYearData] = useState(
  //   restDataYear === 2019
  //     ? ConstituencyListData2019?.candidate
  //     : ConstituencyListData2019?.candidate_2014
  // );


  var _useState3 = (0,react.useState)(ConstituencyListData2019 === null || ConstituencyListData2019 === void 0 ? void 0 : ConstituencyListData2019["candidate_".concat(prevYear[0])]),
      resultYearData = _useState3[0],
      setResultYearData = _useState3[1];

  var currentConstData = constituencyArray.filter(function (x) {
    return x.cons_id == consId;
  });
  console.log("Cons page data ", ConstituencyListData2019, ConstituencyListData2024, constituencyArray);
  var placeName = consName.split("-").join(" ").slice(0, 1).toUpperCase() + consName.split("-").join(" ").slice(1);
  var stateName = state.split("-").join(" ").slice(0, 1).toUpperCase() + state.split("-").join(" ").slice(1);
  console.log("Currents statename", stateName, state);

  var _useState4 = (0,react.useState)(""),
      language = _useState4[0],
      setLanguage = _useState4[1];

  var size = (0,commonConstants/* useWindowSize */.iP)();
  var router = (0,next_router.useRouter)();
  (0,react.useEffect)(function () {
    setLanguage((0,i8intl/* getLanguage */.G3)());
  }, []);
  (0,react.useEffect)(function () {
    setLanguage((0,i8intl/* getLanguage */.G3)());
    setTimeout(function () {
      window.googletag = window.googletag || {
        cmd: []
      };

      if (window.screen.width > 600) {
        googletag.cmd.push(function () {
          googletag.defineSlot("/1007232/Lallantop_Desktop_ROS_ATF_728x90", [[728, 90], [970, 250], [970, 90]], "div-gpt-ad-1701945163318-0").addService(googletag.pubads());
          googletag.defineSlot("/1007232/Lallantop_Desktop_ROS_MTF_1_728x90", [728, 90], "div-gpt-ad-1701945220410-1").addService(googletag.pubads()); //  googletag.defineOutOfPageSlot('/1007232/Lallantop_Mobile_HP_Mweb_Interstitial',googletag.enums.OutOfPageFormat.INTERSTITIAL).addService(googletag.pubads());

          googletag.pubads().enableSingleRequest();
          googletag.pubads().setTargeting("Category", [""]);
          googletag.pubads().setTargeting("Keywords", "");
          googletag.enableServices();
        });
      } else {
        googletag.cmd.push(function () {
          googletag.defineSlot("/1007232/Lallantop_Mobile_ROS_ATF_300x250", [[336, 280], [300, 250]], "div-gpt-ad-1701946028239-0").addService(googletag.pubads());
          googletag.defineSlot("/1007232/Lallantop_Mobile_ROS_MTF_1_300x250", [[336, 280], [300, 250]], "div-gpt-ad-1701946028239-1").addService(googletag.pubads());
          googletag.defineSlot("/1007232/Lallantop_Mobile_HP_Bottom_320x50", [320, 50], "div-gpt-ad-1701946324333-0").addService(googletag.pubads());
          googletag.pubads().enableSingleRequest();
          googletag.pubads().setTargeting("Category", [""]);
          googletag.pubads().setTargeting("Keywords", "");
          googletag.enableServices();
        });
      }

      googletag.pubads().refresh(); // console.log("apstag", typeof apstag);
      // if (typeof apstag !== "undefined") {
      //   apstag.init({
      //     pubID: "7f0bbd82-5a13-48ec-9950-fcb028b1546c",
      //     adServer: "googletag",
      //     bidTimeout: 2e3,
      //   });
      //   // request the bids for the four googletag slots
      //   apstag.fetchBids(
      //     {
      //       slots: [
      //       ],
      //     },
      //     function (bids) {
      //       // set apstag bids, then trigger the first request to GAM
      //       googletag.cmd.push(function () {
      //         apstag.setDisplayBids();
      //         googletag.pubads().refresh();
      //       });
      //     }
      //   );
      // }
    }, 500);
  }, []); // const [prevData, setPrevData] = useState([]);

  var constituencyId = consId;
  var website = "llt";
  var colorOptions = (_colorOptions = {
    llt: "#eb0e8c",
    tg: "#d9368b",
    mz: "#8ab3dc",
    mp: "#0c8a70",
    cg: "#2d8468"
  }, (0,defineProperty/* default */.Z)(_colorOptions, "llt", "#d9368b"), (0,defineProperty/* default */.Z)(_colorOptions, "rj", "#fed029"), (0,defineProperty/* default */.Z)(_colorOptions, "up", "#f6523e"), (0,defineProperty/* default */.Z)(_colorOptions, "gj", "#f362b3"), (0,defineProperty/* default */.Z)(_colorOptions, "ct", "#B71F33"), (0,defineProperty/* default */.Z)(_colorOptions, "mt", "#f92929"), _colorOptions);
  (0,react.useEffect)(function () {
    var data = ConstituencyListData2019 === null || ConstituencyListData2019 === void 0 ? void 0 : ConstituencyListData2019["candidate_".concat(restDataYear)];

    if (data.length > 0) {
      setResultYearData(data);
    } else {
      setResultYearData([]);
    }
  }, [restDataYear]); // useEffect(() => {
  //   const temp = ConstituencyListData2019?.[`candidate_${restDataYear}`]
  //   debugger
  //   if (restDataYear === 2019) {
  //     setResultYearData(ConstituencyListData2019?.[`candidate_${restDataYear}`]);
  //   } else if (restDataYear === 2014) {
  //     setResultYearData(ConstituencyListData2019?.[`candidate_${restDataYear}`]);
  //   } else if (restDataYear === ${displayYear}) {
  //     setResultYearData(ConstituencyListData2024?.candidate);
  //   } else {
  //     setResultYearData([]);
  //   }
  // }, [restDataYear]);

  var mainUrl = "all";
  var consNameCamel = consName.charAt(0).toUpperCase() + consName.slice(1);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("script", {
        id: "my-script-detail",
        type: "application/ld+json",
        strategy: "afterInteractive",
        dangerouslySetInnerHTML: {
          __html: JSON.stringify({
            "@context": "http://schema.org/",
            "@type": "WebPage",
            name: "".concat(consNameCamel, " Assembly Election ").concat(displayYear, ":  ").concat(consNameCamel, " Election Candidates List,  ").concat(consNameCamel, " Results,  ").concat(consNameCamel, " Chunav Results"),
            description: "".concat(consNameCamel, " Assembly Chunav ").concat(displayYear, " (").concat(consNameCamel, " \u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u091A\u0941\u0928\u093E\u0935 ").concat(displayYear, "): Find here ").concat(consNameCamel, " Assembly Election party-wise candidate list, winner, runner-up list, live election result updates (constituency name), photos, videos and news in hindi"),
            keywords: "".concat(consNameCamel, " elections ").concat(displayYear, ",\n          ").concat(consNameCamel, " assembly elections ").concat(displayYear, ",\n          ").concat(consNameCamel, " assembly elections results ").concat(displayYear, ",\n          ").concat(consNameCamel, " assembly elections ").concat(displayYear, " results,\n          ").concat(consNameCamel, " assembly election live results"),
            url: "https://www.thelallantop.com".concat(router.asPath),
            publisher: {
              "@type": "Organization",
              name: "The Lallantop",
              url: "https://www.thelallantop.com/",
              logo: {
                "@type": "ImageObject",
                url: "https://www.thelallantop.com/assets/images/lallatop-logo-m.svg",
                width: 600,
                height: 60
              }
            }
          })
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
        id: "my-script-detail",
        type: "application/ld+json",
        strategy: "afterInteractive",
        dangerouslySetInnerHTML: {
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [{
              "@type": "ListItem",
              position: 1,
              item: {
                "@id": "".concat("https://www.thelallantop.com"),
                name: "Home"
              }
            }, {
              "@type": "ListItem",
              position: 2,
              item: {
                name: "Election",
                "@id": "".concat("https://www.thelallantop.com", "/election")
              }
            }, {
              "@type": "ListItem",
              position: 3,
              item: {
                name: "".concat(state, " Election Results"),
                "@id": "".concat("https://www.thelallantop.com", "/election/").concat(state.toLowerCase(), "-assembly-chunav")
              }
            }, {
              "@type": "ListItem",
              position: 4,
              item: {
                name: "".concat(consName, " Election Results"),
                "@id": "".concat("https://www.thelallantop.com").concat(router.asPath)
              }
            }]
          })
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
        id: "my-script-detail",
        type: "application/ld+json",
        strategy: "afterInteractive",
        dangerouslySetInnerHTML: {
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "SiteNavigationElement",
            name: ["होम", "चुनाव", "न्यूज़", "एंटरटेनमेंट", "ऑडनारी", "टेक्नोलॉजी", "पड़ताल", "बिज़नेस", "लल्लनख़ास", "स्पोर्ट्स", "रंगरूट"],
            url: ["https://www.thelallantop.com/", "https://www.thelallantop.com/election", "https://www.thelallantop.com/news", "https://www.thelallantop.com/entertainment", "https://www.thelallantop.com/oddnaari", "https://www.thelallantop.com/technology", "https://www.thelallantop.com/factcheck", "https://www.thelallantop.com/business", "https://www.thelallantop.com/lallankhas", "https://www.thelallantop.com/sports", "https://www.thelallantop.com/education"]
          })
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "preconnect",
        crossOrigin: "true",
        href: "https://static.chartbeat.com"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
        async: true,
        dangerouslySetInnerHTML: {
          __html: "\n            (function () {\n              var _sf_async_config = window._sf_async_config = (window._sf_async_config || {});\n              _sf_async_config.uid = 60355;\n              _sf_async_config.domain = 'thelallantop.com';\n              _sf_async_config.useCanonical = true;\n              _sf_async_config.useCanonicalDomain = true;\n              _sf_async_config.sections = 'home'; \n              _sf_async_config.authors = '';\n              function loadChartbeat() {\n                  var e = document.createElement('script');\n                  var n = document.getElementsByTagName('script')[0];\n                  e.type = 'text/javascript';\n                  e.async = true;\n                  e.src = '//static.chartbeat.com/js/chartbeat.js';\n                  n.parentNode.insertBefore(e, n);\n              }\n              loadChartbeat();\n          })();\n       "
        },
        strategy: "afterInteractive",
        id: "chartbeat",
        type: "text/javascript"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: "".concat(consNameCamel, " Assembly Election ").concat(displayYear, ":  ").concat(consNameCamel, " Election Candidates List,  ").concat(consNameCamel, " Results,  ").concat(consNameCamel, " Chunav Results"),
      description: "".concat(consNameCamel, " Assembly Chunav ").concat(displayYear, " (").concat(consNameCamel, " \u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u091A\u0941\u0928\u093E\u0935 ").concat(displayYear, "): Find here ").concat(consNameCamel, " Assembly Election party-wise candidate list, winner, runner-up list, live election result updates (constituency name), photos, videos and news in hindi"),
      canonical: "".concat("https://www.thelallantop.com").concat(router.asPath)
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "keywords",
      content: "".concat(consNameCamel, " elections ").concat(displayYear, ",\n          ").concat(consNameCamel, " assembly elections ").concat(displayYear, ",\n          ").concat(consNameCamel, " assembly elections results ").concat(displayYear, ",\n          ").concat(consNameCamel, " assembly elections ").concat(displayYear, " results,\n          ").concat(consNameCamel, " assembly election live results")
    }), size.width > 600 ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: size.width >= 600 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        style: {
          position: "relative",
          display: "flex",
          justifyContent: "center"
        },
        children: [router.asPath.includes("election") && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          style: {
            position: "relative"
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "/assets/images/election-background-3.png",
            style: {
              position: "relative",
              width: "100%",
              height: "298px"
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "/assets/images/left-election-top-2.png",
            width: "",
            height: "170px",
            style: {
              position: "absolute",
              bottom: "10px",
              left: "10px"
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: router.asPath.includes("haryana-assembly") ? "/assets/images/right-election-top-2.png" : router.asPath.includes("jammu-kashmir-assembly") ? "/assets/images/jammu-kashmir.png" : "/assets/images/indian-map.png",
            width: "",
            height: "250px",
            style: {
              position: "absolute",
              bottom: "0",
              right: "0px"
            }
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Container/* default */.Z, {
          align: "center",
          style: {
            position: router.asPath.includes("/election") ? "absolute" : "relative",
            top: router.asPath.includes("/election") ? "22px" : "0px"
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "container-row py-2",
            align: "center",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              style: {
                fontSize: "11px",
                color: "#b7b7b7",
                textAlign: "center",
                marginBottom: "0px"
              },
              children: "Advertisement"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              id: "div-gpt-ad-1701945163318-0",
              style: {
                minWidth: "300px",
                minHeight: "100px",
                display: "block !important",
                alignContent: "center",
                textAlign: "-webkit-center"
              },
              className: "ads-auto-resize",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
                type: "text/javascript",
                dangerouslySetInnerHTML: {
                  __html: "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945163318-0')})"
                }
              })
            })]
          })
        })]
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      style: {
        position: "relative",
        width: "100%"
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: "/assets/images/election-background-mobile.png",
        style: {
          position: "relative",
          width: "100%",
          height: "auto"
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: "/assets/images/election-left-mobile.png",
        width: "",
        height: "70px",
        style: {
          position: "absolute",
          bottom: "10px",
          left: "10px"
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: router.asPath.includes("haryana-assembly") ? "/assets/images/right-election-top-2.png" : router.asPath.includes("jammu-kashmir-assembly") ? "/assets/images/jammu-kashmir.png" : "/assets/images/indian-map.png",
        width: "",
        height: "90px",
        style: {
          position: "absolute",
          bottom: "0",
          right: "0px"
        }
      })]
    }), size.width > 768 ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        style: {
          display: "flex",
          justifyContent: "center",
          backgroundColor: "white",
          width: "max-content",
          margin: "auto",
          gap: "68px",
          height: "80px",
          marginTop: "15px",
          borderRadius: "12px",
          padding: "0px 30px"
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          style: {
            display: "flex",
            justifyContent: "center",
            // paddingTop: "1rem",
            gap: "8px",
            // cursor: "pointer",
            backgroundColor: "white",
            paddingLeft: "0px"
          } // onClick={() =>
          //   window.open("/election/lok-sabha-chunav-${displayYear}", "_self")
          // }
          ,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "/assets/images/assembly-chunav.png",
            width: "408.56px",
            height: "58.21px",
            style: {
              alignSelf: "center"
            }
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          "class": "divCategoriesSchedule2 snipcss-eqdpv",
          style: {
            margin: "0px 0px",
            // backgroundColor: "rgb(217, 54, 139)",
            paddingLeft: "15px",
            alignContent: "center" // display : "flex",
            // justifyContent : "center"

          },
          children: breadCrump.length > 0 && breadCrump.map(function (item, index) {
            return masterConfig[item.keyToShow] != false ? /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: item.url,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: item.displayText
              })
            }, index) : null;
          })
        })]
      })
    }) :
    /*#__PURE__*/
    // mobile breadcrump 
    (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          style: {
            display: "flex",
            justifyContent: "center",
            paddingTop: "1rem",
            gap: "8px",
            // cursor: "pointer",
            paddingBottom: "1rem",
            backgroundColor: "white",
            marginTop: "10px"
          } // onClick={() =>
          //   window.open("/election/lok-sabha-chunav-${displayYear}", "_self")
          // }
          ,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "/assets/images/assembly-chunav.png",
            width: "240px",
            height: "auto",
            style: {
              alignSelf: "center"
            }
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          "class": "divCategoriesSchedule2 snipcss-eqdpv",
          style: {
            margin: "-1px 0px",
            backgroundColor: "white",
            paddingLeft: "15px",
            paddingBottom: "1rem",
            display: "flex",
            justifyContent: ""
          },
          children: breadCrump.length > 0 && // breadCrump.map(item => {
          //   return <a href={item.url}>
          //   <span>{item.displayText}</span>
          // </a>
          // })
          breadCrump.map(function (item, index) {
            return masterConfig[item.keyToShow] != false ? /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: item.url,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: item.displayText
              })
            }, index) : null;
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), size.width <= 768 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "container-row py-2",
      align: "center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        style: {
          fontSize: "11px",
          color: "#b7b7b7",
          textAlign: "center",
          marginBottom: "0px"
        },
        children: "Advertisement"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        id: "div-gpt-ad-1701946028239-0",
        style: {
          minWidth: "300px",
          minHeight: "260px",
          maxHeight: "265px",
          display: "block !important",
          alignContent: "center",
          textAlign: "-webkit-center"
        },
        className: "ads-auto-resize",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
          type: "text/javascript",
          dangerouslySetInnerHTML: {
            __html: "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-0')})"
          }
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Tally/* default */.Z, {
      stateName: constants_state/* stateData */.i[electionState].tallyState,
      masterConfig: masterConfig
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      className: "breadcrumb assembly-breadcrumb",
      style: {
        margin: "auto",
        marginBottom: "20px"
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "/",
          passHref: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            "aria-label": "Lallantop Home",
            style: {
              display: "flex",
              marginTop: "2px"
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("i", {
              className: "icon-cat-home"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "Home"
            })]
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "/election",
          passHref: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            "aria-label": "Lallantop Home",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "Election"
            })
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "/election/".concat(electionState, "/results"),
          passHref: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            "aria-label": "Lallantop Home",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
              children: [stateName, " Election Results"]
            })
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          children: [" ", placeName, " Election Results"]
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ElectionsWidget/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "lok-sabha-main",
      style: {
        background: "white"
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "result-page",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
          children: " ".concat((_currentConstData$ = currentConstData[0]) === null || _currentConstData$ === void 0 ? void 0 : _currentConstData$.cons_name_hi, " \u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u091A\u0941\u0928\u093E\u0935 ").concat(displayYear, " (").concat((_currentConstData$2 = currentConstData[0]) === null || _currentConstData$2 === void 0 ? void 0 : _currentConstData$2.cons_name, " Assembly Election)")
        }), currentYear != cYear ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          style: {
            fontSize: "18px"
          },
          children: router.query.electionState.includes("delhi-assembly-chunav") ? "\u0926\u093F\u0932\u094D\u0932\u0940 \u0915\u0940 ".concat((_currentConstData$3 = currentConstData[0]) === null || _currentConstData$3 === void 0 ? void 0 : _currentConstData$3.cons_name_hi, " (").concat((_currentConstData$4 = currentConstData[0]) === null || _currentConstData$4 === void 0 ? void 0 : _currentConstData$4.cons_name, ") \u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u0938\u0940\u091F \u092A\u0930 \u0915\u094C\u0928 \u091A\u0932 \u0930\u0939\u093E \u0939\u0948 \u0906\u0917\u0947? \u0924\u0940\u0938\u0930\u0947 \u0928\u0902\u092C\u0930 \u092A\u0930 \u0915\u094C\u0928 \u0938\u093E \u0909\u092E\u094D\u092E\u0940\u0926\u0935\u093E\u0930 \u0939\u0948? \u092F\u093E \u0915\u094B\u0908 \u0928\u093F\u0930\u094D\u0926\u0932\u0940\u092F \u092C\u093F\u0917\u093E\u0921\u093C \u0930\u0939\u093E \u0939\u0948 \u0916\u0947\u0932? \u0907\u0938 \u0938\u0940\u091F \u0915\u093E \u092A\u0942\u0930\u093E \u0932\u0947\u0916\u093E-\u091C\u094B\u0916\u093E \u091C\u093E\u0928\u093F\u090F \u092C\u0938 \u090F\u0915 \u0915\u094D\u0932\u093F\u0915 \u092E\u0947\u0902\u0964 \u090F\u0915-\u090F\u0915 \u0930\u093E\u0909\u0902\u0921 \u0915\u0940 \u0938\u092C\u0938\u0947 \u0924\u0947\u091C \u0914\u0930 \u0938\u091F\u0940\u0915 \u091C\u093E\u0928\u0915\u093E\u0930\u0940 \u0938\u093F\u0930\u094D\u092B \u0926\u0940 \u0932\u0932\u094D\u0932\u0928\u091F\u0949\u092A \u092A\u0930\u0964") : "2019 \u0915\u0947 \u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u091A\u0941\u0928\u093E\u0935 \u092E\u0947\u0902 ".concat((_currentConstData$5 = currentConstData[0]) === null || _currentConstData$5 === void 0 ? void 0 : _currentConstData$5.cons_name_hi, " (").concat((_currentConstData$6 = currentConstData[0]) === null || _currentConstData$6 === void 0 ? void 0 : _currentConstData$6.cons_name, ") \u0938\u0940\u091F \u0938\u0947 \u0915\u094C\u0928 \u091C\u0940\u0924\u093E \u0914\u0930 \u0915\u094C\u0928 \u0939\u093E\u0930\u093E? \n  \u0924\u0940\u0938\u0930\u0947 \u0928\u0902\u092C\u0930 \u092A\u0930 \u0915\u094C\u0928 \u0938\u0940 \u092A\u093E\u0930\u094D\u091F\u0940 \u0925\u0940 \u092F\u093E \u092B\u093F\u0930 \u0928\u093F\u0930\u094D\u0926\u0932\u0940\u092F? 2014 \u092E\u0947\u0902 ").concat((_currentConstData$7 = currentConstData[0]) === null || _currentConstData$7 === void 0 ? void 0 : _currentConstData$7.cons_name_hi, " \u0938\u0940\u091F \u092A\u0930 \u0915\u093F\u0938\u0915\u0947 \u092C\u0940\u091A \u092E\u0941\u0915\u093E\u092C\u0932\u093E \u0925\u093E \u0914\u0930 \u0915\u093F\u0938\u0915\u0947 \u0938\u093F\u0930 \u091C\u0940\u0924 \u0915\u093E \u0938\u0947\u0939\u0930\u093E \u092C\u0902\u0927\u093E \u0925\u093E? \n  \u0938\u093E\u0930\u0940 \u091C\u093E\u0928\u0915\u093E\u0930\u0940 \u0906\u092A\u0915\u0940 \u0938\u0940\u091F \u0915\u0947 \u0939\u093F\u0938\u093E\u092C \u0938\u0947\u0964 \u092C\u0938 \u0938\u0947\u0932\u0947\u0915\u094D\u091F \u0915\u0930\u0947\u0902 \u0914\u0930 \u0938\u093E\u0930\u0940 \u091C\u093E\u0928\u0915\u093E\u0930\u0940 \u0906\u092A\u0915\u0940 \u0938\u094D\u0915\u094D\u0930\u0940\u0928 \u092A\u0930\u0964 \n  ").concat(displayYear, " \u0915\u0947 \u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u091A\u0941\u0928\u093E\u0935 \u0915\u0940 \u0939\u0930 \u0938\u0940\u091F \u0915\u093E \u0930\u093F\u091C\u0932\u094D\u091F \u092D\u0940 \u0906\u092A\u0915\u094B \u092F\u0939\u0940\u0902 \u092E\u093F\u0932\u0947\u0917\u093E, \u0938\u093F\u0930\u094D\u092B \u0926\u0940 \u0932\u0932\u094D\u0932\u0928\u091F\u0949\u092A \u092A\u0930\u0964")
        }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [stateHindi, " \u0915\u0940", " ", (_currentConstData$8 = currentConstData[0]) === null || _currentConstData$8 === void 0 ? void 0 : _currentConstData$8.cons_name_hi, " \u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u0938\u0940\u091F \u092A\u0930 \u0915\u094C\u0928 \u091A\u0932 \u0930\u0939\u093E \u0939\u0948 \u0906\u0917\u0947? \u0924\u0940\u0938\u0930\u0947 \u0928\u0902\u092C\u0930 \u092A\u0930 \u0939\u0948 \u0915\u094C\u0928 \u0938\u093E \u0909\u092E\u094D\u092E\u0940\u0926\u0935\u093E\u0930? \u092F\u093E \u0915\u094B\u0908 \u0928\u093F\u0930\u094D\u0926\u0932\u0940\u092F \u092C\u093F\u0917\u093E\u0921\u093C \u0930\u0939\u093E \u0939\u0948 \u0916\u0947\u0932? \u0907\u0938 \u0938\u0940\u091F \u0915\u093E \u092A\u0942\u0930\u093E \u0932\u0947\u0916\u093E \u091C\u094B\u0916\u093E \u091C\u093E\u0928\u093F\u090F \u092C\u0938 \u090F\u0915 \u0915\u094D\u0932\u093F\u0915 \u092E\u0947\u0902. \u090F\u0915-\u090F\u0915 \u0930\u093E\u0909\u0902\u0921 \u0915\u0940 \u0938\u092C\u0938\u0947 \u0924\u0947\u091C \u0914\u0930 \u0938\u091F\u0940\u0915 \u091C\u093E\u0928\u0915\u093E\u0930\u0940 \u0938\u093F\u0930\u094D\u092B \u0926\u0940 \u0932\u0932\u094D\u0932\u0928\u091F\u0949\u092A \u092A\u0930."]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("h2", {
          className: "winner-box-header",
          style: {
            fontSize: "22px",
            fontWeight: "700",
            borderColor: colorOptions["llt"]
          },
          children: ["\u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u091A\u0941\u0928\u093E\u0935 (", (_currentConstData$9 = currentConstData[0]) === null || _currentConstData$9 === void 0 ? void 0 : _currentConstData$9.cons_name_hi, ")"]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "assembly-buttons",
          children: tabs.map(function (item) {
            return (masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig[item.keyToShow]) != false ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              onClick: function onClick() {
                window.location.href = item.url;
              },
              className: item.showActive ? "assembly-buttons-btn-active" : "assembly-buttons-btn",
              children: item.text
            }) : null;
          })
        }), currentYear == cYear ? /*#__PURE__*/(0,jsx_runtime.jsx)(ResponsiveCard, {
          constituencyListData: ConstituencyListData2024,
          selectedConstituencyId: constituencyId,
          colorCode: colorOptions[website],
          constId: constituencyId,
          constituencyArray: constituencyArray,
          t: 't',
          electionState: electionState
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ResponsiveCard, {
          constituencyListData: ConstituencyListData2019,
          selectedConstituencyId: constituencyId,
          colorCode: colorOptions[website],
          constId: constituencyId,
          constituencyArray: constituencyArray,
          t: 'b',
          electionState: electionState
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [console.log("Checking both data", ConstituencyListData2019, ConstituencyListData2024), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), (ConstituencyListData2024 === null || ConstituencyListData2024 === void 0 ? void 0 : (_ConstituencyListData = ConstituencyListData2024.candidate) === null || _ConstituencyListData === void 0 ? void 0 : _ConstituencyListData.length) > 0 && currentYear == cYear && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "winners-list-box",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h3", {
              className: "winner-box-header",
              style: {
                letterSpacing: "normal",
                borderColor: colorOptions["llt"]
              },
              children: ["\u091A\u0941\u0928\u093E\u0935 ", currentYear, " \u0915\u0947 \u0909\u092E\u094D\u092E\u0940\u0926\u0935\u093E\u0930"]
            }), (ConstituencyListData2024 === null || ConstituencyListData2024 === void 0 ? void 0 : (_ConstituencyListData2 = ConstituencyListData2024.candidate) === null || _ConstituencyListData2 === void 0 ? void 0 : _ConstituencyListData2.length) > 0 && (ConstituencyListData2024 === null || ConstituencyListData2024 === void 0 ? void 0 : (_ConstituencyListData3 = ConstituencyListData2024.candidate[0]) === null || _ConstituencyListData3 === void 0 ? void 0 : _ConstituencyListData3.status) === "WON" && dryRun == true && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "winner-box",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "winner-box-heading",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  style: {
                    alignSelf: "center",
                    fontSize: "20px"
                  },
                  children: "\u0935\u093F\u091C\u0947\u0924\u093E"
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  style: {
                    display: "flex",
                    alignItems: "center",
                    gap: "5px"
                  },
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    // add link here
                    onClick: function onClick() {
                      var _ConstituencyListData4, _ConstituencyListData5, _ConstituencyListData6;

                      masterConfig.Show_Candidate_Profile ? window.open("".concat("https://www.thelallantop.com", "/election/").concat(electionState, "/candidate-").concat(ConstituencyListData2024 === null || ConstituencyListData2024 === void 0 ? void 0 : (_ConstituencyListData4 = ConstituencyListData2024.candidate[0]) === null || _ConstituencyListData4 === void 0 ? void 0 : (_ConstituencyListData5 = _ConstituencyListData4.candidate) === null || _ConstituencyListData5 === void 0 ? void 0 : _ConstituencyListData5.toLowerCase().replace(/[^a-zA-Z ]/g, "").split(" ").join("-"), "-").concat(ConstituencyListData2024 === null || ConstituencyListData2024 === void 0 ? void 0 : (_ConstituencyListData6 = ConstituencyListData2024.candidate[0]) === null || _ConstituencyListData6 === void 0 ? void 0 : _ConstituencyListData6.id, "-").concat(consId), "_self") : "";
                    },
                    style: masterConfig !== null && masterConfig !== void 0 && masterConfig.Show_Candidate_Profile ? {
                      // textAlign: "center",
                      cursor: "pointer",
                      textDecoration: "underline",
                      fontSize: "18px"
                    } : {
                      fontSize: "18px"
                    },
                    children: [(ConstituencyListData2024 === null || ConstituencyListData2024 === void 0 ? void 0 : ConstituencyListData2024.candidate) && (ConstituencyListData2024 === null || ConstituencyListData2024 === void 0 ? void 0 : (_ConstituencyListData7 = ConstituencyListData2024.candidate[0]) === null || _ConstituencyListData7 === void 0 ? void 0 : _ConstituencyListData7.candidate), ", ", (ConstituencyListData2024 === null || ConstituencyListData2024 === void 0 ? void 0 : ConstituencyListData2024.candidate) && (ConstituencyListData2024 === null || ConstituencyListData2024 === void 0 ? void 0 : (_ConstituencyListData8 = ConstituencyListData2024.candidate[0]) === null || _ConstituencyListData8 === void 0 ? void 0 : _ConstituencyListData8.party)]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                    width: "40px",
                    height: "40px",
                    src: (ConstituencyListData2024 === null || ConstituencyListData2024 === void 0 ? void 0 : ConstituencyListData2024.candidate) && (ConstituencyListData2024 === null || ConstituencyListData2024 === void 0 ? void 0 : (_ConstituencyListData9 = ConstituencyListData2024.candidate[0]) === null || _ConstituencyListData9 === void 0 ? void 0 : _ConstituencyListData9.party_logo)
                  })]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "winner-box-heading-2",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  style: {
                    alignSelf: "center"
                  },
                  children: "\u0935\u094B\u091F"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  style: {
                    fontSize: "18px",
                    alignSelf: "center"
                  },
                  children: (ConstituencyListData2024 === null || ConstituencyListData2024 === void 0 ? void 0 : ConstituencyListData2024.candidate) && (ConstituencyListData2024 === null || ConstituencyListData2024 === void 0 ? void 0 : (_ConstituencyListData10 = ConstituencyListData2024.candidate[0]) === null || _ConstituencyListData10 === void 0 ? void 0 : _ConstituencyListData10.votes)
                })]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("table", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("th", {
                style: {
                  background: colorOptions[website],
                  textAlign: "left"
                },
                children: "\u0928\u093E\u092E"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("th", {
                style: {
                  background: colorOptions[website]
                },
                children: "\u092A\u093E\u0930\u094D\u091F\u0940"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("th", {
                style: {
                  background: colorOptions[website]
                },
                children: "\u0935\u094B\u091F"
              }), (masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.isElectionAlpha) == true && (ConstituencyListData2024 === null || ConstituencyListData2024 === void 0 ? void 0 : ConstituencyListData2024.candidate.map(function (candidate, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                  children: size.width < 768 ? /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
                    className: index % 2 !== 0 ? "oddColor" : "" // onClick={() =>
                    //   (window.location = `/elections/constituency-list-2019/${con?.ac_no}`)
                    // }
                    ,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                      //add link here
                      onClick: function onClick() {
                        var _candidate$candidate;

                        masterConfig.Show_Candidate_Profile && (candidate === null || candidate === void 0 ? void 0 : candidate.candidate) != 'NOTA' ? window.open("".concat("https://www.thelallantop.com", "/election/").concat(electionState, "/candidate-").concat(candidate === null || candidate === void 0 ? void 0 : (_candidate$candidate = candidate.candidate) === null || _candidate$candidate === void 0 ? void 0 : _candidate$candidate.toLowerCase().replace(/[^a-zA-Z ]/g, "").split(" ").join("-"), "-").concat(candidate === null || candidate === void 0 ? void 0 : candidate.id, "-").concat(consId), "_self") : "";
                      },
                      style: masterConfig !== null && masterConfig !== void 0 && masterConfig.Show_Candidate_Profile && (candidate === null || candidate === void 0 ? void 0 : candidate.candidate) != 'NOTA' ? {
                        // textAlign: "center",
                        cursor: "pointer",
                        textDecoration: "underline",
                        fontSize: "18px"
                      } : {
                        fontSize: "18px"
                      },
                      className: "candidate_name",
                      children: candidate === null || candidate === void 0 ? void 0 : candidate.candidate
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("td", {
                      style: {
                        fontSize: "16px",
                        // display:"flex",
                        // gap:"15px",
                        // paddingLeft:"5%"
                        textAlign: "center"
                      },
                      className: "candidate_name",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                          width: "20px",
                          height: "20px",
                          style: {
                            borderRadius: "100%"
                          },
                          src: candidate === null || candidate === void 0 ? void 0 : candidate.party_logo
                        })
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        children: candidate === null || candidate === void 0 ? void 0 : candidate.party
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                      className: "winner-name",
                      style: {
                        textAlign: "center",
                        borderLeftColor: "#d2d1d1",
                        borderLeftWidth: "0.2px"
                      },
                      children: (candidate === null || candidate === void 0 ? void 0 : candidate.win_loss) === "Result Awaited" ? "Result Awaited" : dryRun == true ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        style: {
                          display: "flex",
                          gap: "10px",
                          margin: "auto",
                          width: "auto",
                          justifyContent: "center"
                        },
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                          style: {
                            margin: "0",
                            fontSize: "16px"
                          },
                          children: candidate === null || candidate === void 0 ? void 0 : candidate.votes
                        }), " ", (candidate === null || candidate === void 0 ? void 0 : candidate.status_logo) && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                          src: candidate === null || candidate === void 0 ? void 0 : candidate.status_logo,
                          width: "20px",
                          height: "20px"
                        })]
                      }) : "Result Awaited"
                    })]
                  }, candidate === null || candidate === void 0 ? void 0 : candidate.ac_no) : /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
                    className: index % 2 !== 0 ? "oddColor" : "" // onClick={() =>
                    //   (window.location = `/elections/constituency-list-2019/${con?.ac_no}`)
                    // }
                    ,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                      //add link here
                      onClick: function onClick() {
                        var _candidate$candidate2;

                        masterConfig.Show_Candidate_Profile && (candidate === null || candidate === void 0 ? void 0 : candidate.candidate) != 'NOTA' ? window.open("".concat("https://www.thelallantop.com", "/election/").concat(electionState, "/candidate-").concat(candidate === null || candidate === void 0 ? void 0 : (_candidate$candidate2 = candidate.candidate) === null || _candidate$candidate2 === void 0 ? void 0 : _candidate$candidate2.toLowerCase().replace(/[^a-zA-Z ]/g, "").split(" ").join("-"), "-").concat(candidate === null || candidate === void 0 ? void 0 : candidate.id, "-").concat(consId), "_self") : "";
                      },
                      style: masterConfig !== null && masterConfig !== void 0 && masterConfig.Show_Candidate_Profile && (candidate === null || candidate === void 0 ? void 0 : candidate.candidate) != 'NOTA' ? {
                        // textAlign: "center",
                        cursor: "pointer",
                        textDecoration: "underline",
                        fontSize: "18px"
                      } : {
                        fontSize: "18px"
                      },
                      className: "candidate_name",
                      children: candidate === null || candidate === void 0 ? void 0 : candidate.candidate
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("td", {
                      style: {
                        fontSize: "19px",
                        // display:"flex",
                        // gap:"15px",
                        paddingLeft: "5%"
                      },
                      className: "candidate_name",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                        width: "25px",
                        height: "25px",
                        style: {
                          borderRadius: "100%",
                          marginRight: "10px"
                        },
                        src: candidate === null || candidate === void 0 ? void 0 : candidate.party_logo
                      }), candidate === null || candidate === void 0 ? void 0 : candidate.party]
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                      className: "winner-name",
                      style: {
                        textAlign: "center",
                        borderLeftColor: "#d2d1d1",
                        borderLeftWidth: "0.2px"
                      },
                      children: (candidate === null || candidate === void 0 ? void 0 : candidate.win_loss) === "Result Awaited" ? "Result Awaited" : dryRun == true ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        style: {
                          display: "flex",
                          gap: "10px",
                          margin: "auto",
                          width: "auto",
                          justifyContent: "center"
                        },
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                          style: {
                            margin: "0",
                            fontSize: "18px"
                          },
                          children: candidate === null || candidate === void 0 ? void 0 : candidate.votes
                        }), " ", (candidate === null || candidate === void 0 ? void 0 : candidate.status_logo) && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                          src: candidate === null || candidate === void 0 ? void 0 : candidate.status_logo,
                          width: "20px",
                          height: "20px"
                        })]
                      }) : "Result Awaited"
                    })]
                  }, candidate === null || candidate === void 0 ? void 0 : candidate.ac_no)
                });
              }))]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), ((ConstituencyListData2019 === null || ConstituencyListData2019 === void 0 ? void 0 : (_ConstituencyListData11 = ConstituencyListData2019.candidate_2019) === null || _ConstituencyListData11 === void 0 ? void 0 : _ConstituencyListData11.length) > 0 || (ConstituencyListData2019 === null || ConstituencyListData2019 === void 0 ? void 0 : (_ConstituencyListData12 = ConstituencyListData2019.candidate_2014) === null || _ConstituencyListData12 === void 0 ? void 0 : _ConstituencyListData12.length) > 0) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "winner-box-header",
            style: {
              borderColor: colorOptions[website]
            },
            children: "\u0909\u092E\u094D\u092E\u0940\u0926\u0935\u093E\u0930"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "winner-box-years",
            children: [(ConstituencyListData2019 === null || ConstituencyListData2019 === void 0 ? void 0 : (_ConstituencyListData13 = ConstituencyListData2019["candidate_".concat(prevYear[0])]) === null || _ConstituencyListData13 === void 0 ? void 0 : _ConstituencyListData13.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              className: "".concat(restDataYear != prevYear[0] ? "btn-disable" : ""),
              onClick: function onClick() {
                return setRestDataYear(prevYear[0]);
              },
              style: {
                backgroundColor: colorOptions[website]
              },
              children: prevYear[0]
            }), (ConstituencyListData2019 === null || ConstituencyListData2019 === void 0 ? void 0 : (_ConstituencyListData14 = ConstituencyListData2019["candidate_".concat(prevYear[1])]) === null || _ConstituencyListData14 === void 0 ? void 0 : _ConstituencyListData14.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              className: "".concat(restDataYear != prevYear[1] ? "btn-disable" : ""),
              onClick: function onClick() {
                return setRestDataYear(prevYear[1]);
              },
              style: {
                backgroundColor: colorOptions[website]
              },
              children: prevYear[1]
            })]
          }), (ConstituencyListData2019 === null || ConstituencyListData2019 === void 0 ? void 0 : (_ConstituencyListData15 = ConstituencyListData2019["candidate_".concat(restDataYear)]) === null || _ConstituencyListData15 === void 0 ? void 0 : _ConstituencyListData15.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "winner-box",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "winner-box-heading",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                style: {
                  alignSelf: "center",
                  fontSize: "20px"
                },
                children: "\u0935\u093F\u091C\u0947\u0924\u093E"
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                style: {
                  display: "flex",
                  alignItems: "center",
                  gap: "5px"
                },
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  style: {
                    fontSize: "18px"
                  },
                  children: [resultYearData && ((_resultYearData$ = resultYearData[0]) === null || _resultYearData$ === void 0 ? void 0 : _resultYearData$.candidate), ", ", resultYearData && ((_resultYearData$2 = resultYearData[0]) === null || _resultYearData$2 === void 0 ? void 0 : _resultYearData$2.party)]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  width: "40px",
                  height: "40px",
                  src: resultYearData && ((_resultYearData$3 = resultYearData[0]) === null || _resultYearData$3 === void 0 ? void 0 : _resultYearData$3.party_logo)
                })]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "winner-box-heading-2",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                style: {
                  alignSelf: "center"
                },
                children: "\u0935\u094B\u091F"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                style: {
                  fontSize: "18px",
                  alignSelf: "center"
                },
                children: resultYearData && ((_resultYearData$4 = resultYearData[0]) === null || _resultYearData$4 === void 0 ? void 0 : _resultYearData$4.votes)
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "winner-box-heading-2",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                style: {
                  alignSelf: "center"
                },
                children: "\u0935\u093F\u091C\u0947\u0924\u093E \u092A\u093E\u0930\u094D\u091F\u0940 \u0915\u093E \u0935\u094B\u091F %"
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                style: {
                  fontSize: "18px",
                  alignSelf: "center"
                },
                children: [resultYearData && ((_resultYearData$5 = resultYearData[0]) === null || _resultYearData$5 === void 0 ? void 0 : _resultYearData$5.percentage_votes), " %"]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "winner-box-heading-2",
              style: {
                borderBottomLeftRadius: "10px",
                borderBottomRightRadius: "10px"
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                style: {
                  alignSelf: "center"
                },
                children: "\u091C\u0940\u0924 \u0905\u0902\u0924\u0930 %"
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                style: {
                  fontSize: "18px",
                  alignSelf: "center"
                },
                children: [resultYearData && ((_resultYearData$6 = resultYearData[0]) === null || _resultYearData$6 === void 0 ? void 0 : _resultYearData$6.winning_percentage), " %"]
              })]
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), (ConstituencyListData2019 === null || ConstituencyListData2019 === void 0 ? void 0 : (_ConstituencyListData16 = ConstituencyListData2019["candidate_".concat(restDataYear)]) === null || _ConstituencyListData16 === void 0 ? void 0 : _ConstituencyListData16.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "winners-list-box",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "winner-box-header",
            style: {
              borderColor: colorOptions[website]
            },
            children: "\u0905\u0928\u094D\u092F \u0909\u092E\u094D\u092E\u0940\u0926\u0935\u093E\u0930"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("table", {
              "class": "overflow-hidden",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("th", {
                style: {
                  backgroundColor: colorOptions[website],
                  textAlign: "center"
                },
                children: "\u0928\u093E\u092E"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("th", {
                style: {
                  backgroundColor: colorOptions[website],
                  textAlign: "center",
                  borderLeftColor: "white",
                  borderLeftWidth: "1px"
                },
                children: "\u092A\u093E\u0930\u094D\u091F\u0940"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("th", {
                style: {
                  backgroundColor: colorOptions[website],
                  textAlign: "center",
                  borderLeftColor: "white",
                  borderLeftWidth: "1px"
                },
                children: "\u0935\u094B\u091F"
              }), ConstituencyListData2019 && (resultYearData === null || resultYearData === void 0 ? void 0 : resultYearData.slice(1).map(function (con, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                  children: size.width < 768 ? /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
                    className: index % 2 !== 0 ? "oddColor" : "" // style={{ cursor: "pointer" }}
                    // onClick={() =>
                    //   (window.location = `/elections/constituency-list-2019/${con?.ac_no}`)
                    // }
                    ,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                      style: {
                        textAlign: "center",
                        fontSize: "16px"
                      },
                      children: con === null || con === void 0 ? void 0 : con.candidate
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("td", {
                      style: {
                        textAlign: "center",
                        color: con === null || con === void 0 ? void 0 : con.colorCode,
                        borderLeftColor: "#d2d1d1",
                        borderLeftWidth: "0.2px",
                        fontSize: "16px"
                      },
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                          src: con === null || con === void 0 ? void 0 : con.party_logo,
                          width: "20px",
                          height: "20px",
                          style: {
                            borderRadius: "50%"
                          }
                        })
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        children: con === null || con === void 0 ? void 0 : con.party
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                      className: "winner-name",
                      style: {
                        textAlign: "center",
                        borderLeftColor: "#d2d1d1",
                        borderLeftWidth: "0.2px",
                        fontSize: "16px"
                      },
                      children: con === null || con === void 0 ? void 0 : con.votes
                    })]
                  }, index) : /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
                    className: index % 2 !== 0 ? "oddColor" : "" // style={{ cursor: "pointer" }}
                    // onClick={() =>
                    //   (window.location = `/elections/constituency-list-2019/${con?.ac_no}`)
                    // }
                    ,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                      style: {
                        textAlign: "center",
                        fontSize: "18px"
                      },
                      children: con === null || con === void 0 ? void 0 : con.candidate
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("td", {
                      style: {
                        textAlign: "center",
                        color: con === null || con === void 0 ? void 0 : con.colorCode,
                        borderLeftColor: "#d2d1d1",
                        borderLeftWidth: "0.2px",
                        fontSize: "18px"
                      },
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                        src: con === null || con === void 0 ? void 0 : con.party_logo,
                        width: "25px",
                        height: "25px",
                        style: {
                          marginRight: "20px",
                          borderRadius: "50%"
                        }
                      }), con === null || con === void 0 ? void 0 : con.party]
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                      className: "winner-name",
                      style: {
                        textAlign: "center",
                        borderLeftColor: "#d2d1d1",
                        borderLeftWidth: "0.2px",
                        fontSize: "18px"
                      },
                      children: con === null || con === void 0 ? void 0 : con.votes
                    })]
                  }, index)
                });
              }))]
            })
          })]
        })]
      }), constituencyArray && (constituencyArray === null || constituencyArray === void 0 ? void 0 : constituencyArray.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        style: {
          margin: "1rem 0",
          backgroundColor: "#FFF",
          padding: "10px",
          borderRadius: "10px" // backgroundColor: "var(--bg-dark, #000)",

        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          style: {
            color: "#333",
            fontWeight: "bold",
            fontSize: "1.125rem",
            display: "flex",
            alignItems: "center",
            marginBottom: "10px",
            minWidth: "28%"
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            style: {
              color: "#D9368B"
            },
            children: "".concat(stateHindi, " \u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u0928\u093F\u0930\u094D\u0935\u093E\u091A\u0928 \u0915\u094D\u0937\u0947\u0924\u094D\u0930")
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          style: {
            display: "flex",
            flexWrap: "wrap",
            gap: "8px",
            padding: "8px",
            border: "2px solid #E6E7E9",
            borderRadius: "20px"
          },
          children: constituencyArray.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              title: item === null || item === void 0 ? void 0 : item.cons_name,
              href: "".concat("https://www.thelallantop.com", "/election/").concat(electionState, "/results/").concat(item === null || item === void 0 ? void 0 : item.cons_name.toLowerCase().replace(/[^a-zA-Z ]/g, "").split(" ").join("-"), "-constituency-result/").concat(item === null || item === void 0 ? void 0 : item.cons_id),
              target: "_self",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                style: {
                  // backgroundColor:
                  //   item?.cons_id === constituencyId
                  //     ? "#F15C35"
                  //     : "#EEF3F7",
                  // color: item?.cons_id === constituencyId ? "#FFF" : "",
                  border: "2px solid #D2D1D1",
                  margin: "4px 0",
                  borderRadius: "20px",
                  padding: "8px 16px",
                  cursor: "pointer"
                },
                className: (item === null || item === void 0 ? void 0 : item.cons_id) != constituencyId ? "election-box-ptag" : "election-box-ptag-active",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  style: {
                    margin: "0"
                  },
                  children: item === null || item === void 0 ? void 0 : item.cons_name_hi
                })
              }, index)
            }, index);
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Container/* default */.Z, {
        align: "center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "container-row py-2",
          align: "center",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            style: {
              fontSize: "11px",
              color: "#b7b7b7",
              textAlign: "center",
              marginBottom: "0px"
            },
            children: "Advertisement"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            id: size.width > 600 ? "div-gpt-ad-1701945220410-1" : "div-gpt-ad-1701946028239-1",
            style: {
              minWidth: "300px",
              minHeight: size.width > 600 ? "100px" : "260px",
              display: "block !important",
              alignContent: "center",
              textAlign: "-webkit-center"
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
              type: "text/javascript",
              dangerouslySetInnerHTML: {
                __html: size.width > 600 ? "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945220410-1')})" : "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-1')})"
              }
            })
          })]
        }), " "]
      })]
    })]
  });
}

var ResponsiveCard = function ResponsiveCard(_ref2) {
  var _ref2$constituencyLis = _ref2.constituencyListData,
      constituencyListData = _ref2$constituencyLis === void 0 ? [] : _ref2$constituencyLis,
      _ref2$constituencyArr = _ref2.constituencyArray,
      constituencyArray = _ref2$constituencyArr === void 0 ? [] : _ref2$constituencyArr,
      _ref2$selectedConstit = _ref2.selectedConstituencyId,
      selectedConstituencyId = _ref2$selectedConstit === void 0 ? "" : _ref2$selectedConstit,
      _ref2$colorCode = _ref2.colorCode,
      colorCode = _ref2$colorCode === void 0 ? "#000" : _ref2$colorCode,
      _ref2$constId = _ref2.constId,
      constId = _ref2$constId === void 0 ? null : _ref2$constId,
      electionState = _ref2.electionState;
  var router = (0,next_router.useRouter)();

  var _useState5 = (0,react.useState)(false),
      readMore = _useState5[0],
      setReadMore = _useState5[1];

  var _useState6 = (0,react.useState)([]),
      stateList = _useState6[0],
      setStateList = _useState6[1];

  var _useState7 = (0,react.useState)([]),
      constList = _useState7[0],
      setConstList = _useState7[1];

  var _useState8 = (0,react.useState)({}),
      currentState = _useState8[0],
      setCurrentState = _useState8[1];

  var _useState9 = (0,react.useState)({}),
      currentConst = _useState9[0],
      setCurrentConst = _useState9[1];

  var _useState10 = (0,react.useState)(false),
      isChanged = _useState10[0],
      setIsChanged = _useState10[1];

  var _useState11 = (0,react.useState)(constituencyArray),
      prevData = _useState11[0],
      setPrevData = _useState11[1];

  var website = "llt";

  var handleReadMoreClick = function handleReadMoreClick() {
    setReadMore(!readMore);
  };

  console.log("current Obj ", constituencyArray);

  var _useState12 = (0,react.useState)([]),
      dropDownData = _useState12[0],
      setDropdownData = _useState12[1];

  (0,react.useEffect)(function () {
    var ar = [];
    constituencyArray.map(function (item) {
      ar.push({
        label: "".concat(item.cons_name_hi, " (").concat(item.cons_name, ")"),
        value: item.cons_id
      });
    });
    setConstList(ar);
  }, []);
  (0,react.useEffect)(function () {
    var data = constList.filter(function (x) {
      return x.value == constId;
    });
    console.log("Current const", data);

    if (data.length > 0) {
      setCurrentConst(data[0]);
    }
  }, [constList]);
  (0,react.useEffect)(function () {
    if (isChanged && currentConst !== null && typeof currentConst !== "undefined") {
      var _data$, _data$2, _data$3, _data$4;

      var data = constituencyArray.filter(function (item) {
        return (item === null || item === void 0 ? void 0 : item.cons_id) === (currentConst === null || currentConst === void 0 ? void 0 : currentConst.value);
      });
      console.log("Both are ", data);
      window.open("".concat("".concat("https://www.thelallantop.com", "/election/").concat(router.asPath.includes("jammu-kashmir") ? "jammu-kashmir" : "haryana", "-assembly-chunav/results/").concat((_data$ = data[0]) === null || _data$ === void 0 ? void 0 : _data$.cons_name.toLowerCase().replace(/[^a-zA-Z ]/g, "").split(" ").join("-"), "-constituency-result/").concat((_data$2 = data[0]) === null || _data$2 === void 0 ? void 0 : _data$2.cons_id)), "_self");
      window.open("".concat("".concat("https://www.thelallantop.com", "/election/").concat(electionState, "/results/").concat((_data$3 = data[0]) === null || _data$3 === void 0 ? void 0 : _data$3.cons_name.toLowerCase().replace(/[^a-zA-Z ]/g, "").split(" ").join("-"), "-constituency-result/").concat((_data$4 = data[0]) === null || _data$4 === void 0 ? void 0 : _data$4.cons_id)), "_self");
    }
  }, [currentConst]);
  var fullText = "\u0905\u0917\u0930 \u092A\u094D\u0930\u0926\u0947\u0936 \u0915\u093E \u090F\u0915 \u092A\u094D\u0930\u092E\u0941\u0916 \u0928\u0917\u0930 \u0914\u0930 \u0939\u093F\u0938\u094D\u091F\u093E \u0939\u0948 \u0935\u093E\u0930\u093E\u0923\u0938\u0940 \u092C\u093E\u0938\u093E\u0938 \u0914\u0930 \u0915\u093E\u0936\u0940 \u0915\u0947 \u0928\u093E\u092E \u0938\u0947 \u092D\u0940 \u091C\u093E\u0928\u093E \u091C\u093E\u0924\u093E \u0939\u0948. \u0907\u0938 \u0939\u093F\u0938\u094D\u091F\u093E \u092E\u0947\u0902 \u090F\u0915 \u092A\u0924\u0928 \u0928\u0917\u0930 \u092E\u093E\u0928\u093E \u091C\u093E\u0924\u093E \u0939\u0948. \u0920\u0902\u0921 \u0914\u0930 \u0909\u092E\u0938 \u0915\u0947 \u0932\u093F\u090F \u092D\u0940 \u090F\u0915 \u092E\u0939\u0924\u094D\u0935\u092A\u0942\u0930\u094D\u0923 \u0936\u0939\u0930 \u0939\u0948...\n  \u0905\u0917\u0930 \u092A\u094D\u0930\u0926\u0947\u0936 \u0915\u093E \u090F\u0915 \u092A\u094D\u0930\u092E\u0941\u0916 \u0928\u0917\u0930 \u0914\u0930 \u0939\u093F\u0938\u094D\u091F\u093E \u0939\u0948 \u0935\u093E\u0930\u093E\u0923\u0938\u0940 \u092C\u093E\u0938\u093E\u0938 \u0914\u0930 \u0915\u093E\u0936\u0940 \u0915\u0947 \u0928\u093E\u092E \u0938\u0947 \u092D\u0940 \u091C\u093E\u0928\u093E \u091C\u093E\u0924\u093E \u0939\u0948. \u0907\u0938 \u0939\u093F\u0938\u094D\u091F\u093E \u092E\u0947\u0902 \u090F\u0915 \u092A\u0924\u0928 \u0928\u0917\u0930 \u092E\u093E\u0928\u093E \u091C\u093E\u0924\u093E \u0939\u0948. \u0920\u0902\u0921 \u0914\u0930 \u0909\u092E\u0938 \u0915\u0947 \u0932\u093F\u090F \u092D\u0940 \u090F\u0915 \u092E\u0939\u0924\u094D\u0935\u092A\u0942\u0930\u094D\u0923 \u0936\u0939\u0930 \u0939\u0948\n  \u0905\u0917\u0930 \u092A\u094D\u0930\u0926\u0947\u0936 \u0915\u093E \u090F\u0915 \u092A\u094D\u0930\u092E\u0941\u0916 \u0928\u0917\u0930 \u0914\u0930 \u0939\u093F\u0938\u094D\u091F\u093E \u0939\u0948 \u0935\u093E\u0930\u093E\u0923\u0938\u0940 \u092C\u093E\u0938\u093E\u0938 \u0914\u0930 \u0915\u093E\u0936\u0940 \u0915\u0947 \u0928\u093E\u092E \u0938\u0947 \u092D\u0940 \u091C\u093E\u0928\u093E \u091C\u093E\u0924\u093E \u0939\u0948. \u0907\u0938 \u0939\u093F\u0938\u094D\u091F\u093E \u092E\u0947\u0902 \u090F\u0915 \u092A\u0924\u0928 \u0928\u0917\u0930 \u092E\u093E\u0928\u093E \u091C\u093E\u0924\u093E \u0939\u0948. \u0920\u0902\u0921 \u0914\u0930 \u0909\u092E\u0938 \u0915\u0947 \u0932\u093F\u090F \u092D\u0940 \u090F\u0915 \u092E\u0939\u0924\u094D\u0935\u092A\u0942\u0930\u094D\u0923 \u0936\u0939\u0930 \u0939\u0948";
  var previewText = "\u0905\u0917\u0930 \u092A\u094D\u0930\u0926\u0947\u0936 \u0915\u093E \u090F\u0915 \u092A\u094D\u0930\u092E\u0941\u0916 \u0928\u0917\u0930 \u0914\u0930 \u0939\u093F\u0938\u094D\u091F\u093E \u0939\u0948 \u0935\u093E\u0930\u093E\u0923\u0938\u0940...";

  function findConstituency(value) {
    var query = value.toLowerCase();
    var prevData = constituencyArray;
    var newData = prevData.filter(function (item) {
      return item.ac_name.toLowerCase().includes(query) || item.name.toLowerCase().includes(query);
    });
    setPrevData(newData);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "responsive-card shadow-sm",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
      children: "Select Constituency"
    }), constList.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(SearchableDropdown/* default */.Z, {
      options: constList,
      label: "name",
      id: "id",
      selectedVal: currentConst === null || currentConst === void 0 ? void 0 : currentConst.label,
      handleChange: function handleChange(val) {
        setCurrentConst(val);
        setIsChanged(true);
      }
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/election/[electionState]/results/[constituency]/[consId]/index.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// import KaunJeetaCons from "components/vidhansabha/KaunJeetaCons";


var __N_SSP = true;
function Index(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(KaunJeetaConsD, _objectSpread({}, props));
}

/***/ }),

/***/ 18945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var firebase_app__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83977);

var firebaseConfig = {
  apiKey: "AIzaSyA43bFX7ueF-JM0g-weOR0HxqDuQRkXydg",
  authDomain: "thelallantop-5296b.firebaseapp.com",
  databaseURL: "https://thelallantop-5296b.firebaseio.com",
  projectId: "thelallantop-5296b",
  storageBucket: "thelallantop-5296b.appspot.com",
  messagingSenderId: "928164060644",
  appId: "1:928164060644:web:7490092b73d4b3f714bbf1",
  measurementId: "G-L0B4Q7N010"
}; // const firebaseConfig = {
//   apiKey: "AIzaSyBd9I1B7T3yq5xXY5HoU69k1OIcGSBbnHE",
//   authDomain: "lallantop-dev-c5e4c.firebaseapp.com",
//   databaseURL: "https://lallantop-dev-c5e4c-default-rtdb.firebaseio.com",
//   projectId: "lallantop-dev-c5e4c",
//   storageBucket: "lallantop-dev-c5e4c.appspot.com",
//   messagingSenderId: "606538662701",
//   appId: "1:606538662701:web:b9fd13f9130e72f8f689a4",
//   measurementId: "G-KGFH4PGD46"
// };

var app = (0,firebase_app__WEBPACK_IMPORTED_MODULE_0__/* .initializeApp */ .ZF)(firebaseConfig, "appcheck");
/* harmony default export */ __webpack_exports__["Z"] = (app);

/***/ }),

/***/ 38604:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/election/[electionState]/results/[constituency]/[consId]",
      function () {
        return __webpack_require__(79370);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2962,3977,2971,5613,532,2888,179], function() { return __webpack_exec__(38604); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);